import { router } from "@inertiajs/react"

/**
 * Flush all cached entries for a list (active, completed, archived views).
 */
export function flushListCache(listId: number): void {
  const baseUrl = `/lists/${listId}`
  router.flush(baseUrl)
  router.flush(`${baseUrl}?status=completed`)
  router.flush(`${baseUrl}?status=archived`)
}

/**
 * Flush all cached entries for the lists index (all tasks view).
 */
export function flushListsIndexCache(): void {
  router.flush("/lists")
}
